



















































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import CommonUpload from '@/components/CommonUpload'
import CommonProgress from '@/components/CommonProgress'
import { getObsSettingRequest } from '@/api/common'
import { getCurTimeStr, getLocalItem, getObsClient, getTimestamp } from '@/utils'
import  { saveSupervisionRequest } from '@/api/supervision'
@Component({
  name: 'SupervisionUpload',
  components: { CommonUpload ,CommonProgress },
})
export default class SupervisionUpload extends Vue {
  private visible: boolean = true;
  private confirmLoading: boolean = false
  private wordType: string = 'doc,docx'
  private zipType: string ='zip,rar'
  private size: number = 3;
  private videoSize: number = 10*1024
  private obsOption: any ={}
  private enterpriseCode: any | undefined
  private supervisionYear: any |undefined
  private custId:any =getLocalItem('user').custId
  //结果0 整改 1符合
  private supervisionResult: number =0
  private fileTypeList=[{
    id: 0,
    name: '节能监察建议书'
  },{
    id: 1,
    name: '限期整改通知书'
  }]
  handleDocType(val:number){
    this.docType= val
  }
  private docType :number =0
  //限期整改通知书
  private rectificationFile: any | null
  private rectificationFileUrl: any | undefined
  private rectificationFileName: any  | undefined
  //行政处罚决定书
   private punishmentFile: any | null
  private punishmentFileUrl: any | undefined
  private punishmentFileName: any  | undefined
   //节能监察报告
  private reportFile: any | null
  private reportFileUrl: any | undefined
  private reportFileName: any  | undefined
  //节能监察建议书
  private recommendationFile: any | null
  private recommendationFileUrl: any | undefined
  private recommendationFileName: any  | undefined
  //视频佐料
  private videoFile:any |null
  private videoFileName: any | undefined
  private videoFileUrl: any | undefined
   //其他
  private otherFile:any |null
  private otherFileName: any | undefined
  private otherFileUrl: any | undefined
  private prefixKey :string = ''



  private uploadId: any
  @Prop({ default: false }) show!: boolean;
  @Prop({default: 0}) result!: number
  @Prop({type:String}) id!:String
    @Prop({type:Object}) cust!:Object
  @Watch('show')
  onChangeShow() {
    this.visible = this.show
    if (this.visible) {
      this.supervisionResult=this.result
      this.getObsSetting()
    }
  }
  afterClose(){
    this.prefixKey=''
    this.obsOption={}
    this.otherFile=null
    this.videoFile=null
    this.recommendationFile=null
    this.reportFile=null
    this.punishmentFile=null
    this.rectificationFile=null
  }
  // @Emit('clickAction')
  handleOk() {
    this.uploadId = []
   
    if(!this.videoFile){
      this.$message.warning('请上传视频佐证资料')
       return 
    }
    // if(!this.otherFile){
    //   this.$message.warning('请上传其他资料')
    //    return 
    // }
    this.confirmLoading = true
     //  客户id/社会信用统一代码/监察周期/时间戳.type
    this.prefixKey= this.custId+'/'+this.enterpriseCode+'/'+this.supervisionYear+'/'
    
       this.doUploadVideo(this.obsOption, this.videoFile,this.cust)
     
    // if(this.supervisionResult == 0&&this.docType==0){
    //    this.doUploadRecommend(this.obsOption, this.recommendationFile)
    //    return
    // }
    // if(this.supervisionResult == 0&&this.docType==1){
    //    this.doUploadRectification(this.obsOption, this.reportFile)
    //    return
    // }
  
   
  }
  @Emit('clickAction')
  handleCancel() {
    // this.visible = false
    this.$emit('closeUp')
  }
   handleRectificationFile(fileList: any) {
    if (!fileList) {
      return
    }
    if (fileList.length == 0) {
      this.rectificationFile = null
    } else {
       this.rectificationFile = fileList[0]
    }
   
  }
   handlePunishmentFile(fileList: any) {
    if (!fileList) {
      return
    }
    if (fileList.length == 0) {
      this.punishmentFile = null
    } else {
       this.punishmentFile = fileList[0]
    }
   
  }
   handleRecommendFile(fileList: any) {
    if (!fileList) {
      return
    }
    if (fileList.length == 0) {
      this.recommendationFile = null
    }else{
      this.recommendationFile = fileList[0]
    }
    
  }
  handleReportFile(fileList: any) {
    if (!fileList) {
      return
    }
    
    if (fileList.length == 0) {
      this.reportFile = null
    }else{
       this.reportFile = fileList[0]
    }
   
  }
   handleVideoFile(fileList: any) {
     
    if (!fileList) {
      return
    }
    if (fileList.length == 0) {
      this.videoFile = null
    }else{
       this.videoFile = fileList[0]||fileList
    }
   
  }
   handleOtherFile(fileList: any) {
     
    if (!fileList) {
      return
    }
   
    if (fileList.length == 0) {
      this.otherFile = null
    }else{
       this.otherFile = fileList[0]
    }
   
  }
  async getObsSetting() {
    try {
      const result: any = await getObsSettingRequest()
      if (result.status == 0) {
        this.obsOption = result.data
      } else {
        this.$message.error(result.message)
      }
    } catch (error) {}
  }
  // 提交
  saveSupervision(){
    if(!this.visible){
      return false
    }
    const postData = {
      id: this.id,
      fileUrl: this.videoFileUrl,
      fileName: this.videoFileName,
     
    }

    
   
    saveSupervisionRequest(postData).then((res:any)=>{
      this.confirmLoading=false
      if(res.status == 0){
        this.$message.success('提交成功')
        this.$router.replace({name: 'SceneSupervision'})
      }else{
        this.$message.error(res.message)
      }
    })
  }
  

   //上传视频资料
   private videoSpeed:number= 0
   private videoUpPercent:number= 0
   private showVideoProgress:boolean= false
  doUploadVideo(option: any, file: any, cust:any) {
    const fileSize = file.size
    const fileType = file.name.split('.')[1]
    const fileName= cust.enterpriseName+'现场监察佐证'
    const filekey = option.filePath + fileName + '_' + cust.enforcementTime + '.'+ fileType
    const that = this
    if(!this.visible){
      return false
    }
    this.uploadId.push(option)
    getObsClient(option)
      .uploadFile({
        Bucket: option.bucket,
        Key: option.filePath+fileName + '_' + cust.enforcementTime + '.'+ fileType,
        Metadata: { property: 'property-value' },
        SourceFile: file,
        TaskNum: 3,
        ProgressCallback: function (
          transferredAmount: any,//已上传的字节数
          totalAmount: any,//总字节数
          totalSeconds: any //已使用的时间
        ) {
          // debugger
          // if(!that.visible){
          //   return false
          // }
          that.showVideoProgress=true
          that.videoUpPercent= Math.floor(transferredAmount * 100.0 / totalAmount)
          that.videoSpeed= Math.floor(transferredAmount * 1.0 / totalSeconds / 1024)
        },
      })
      .then(function (result: any) {
        if (result.CommonMsg.Status == 200) {
          that.videoFileUrl = filekey
          that.videoFileName = cust.enterpriseName+'现场监察佐证'+ cust.enforcementTime + '.'+ fileType
          
            setTimeout(() => {
              that.saveSupervision()
            }, 500)
        
           
        
        }else{
          that.$message.error(result.CommonMsg.Message) 
        }
      })
      .catch(function (err: any) {
      })
  }
  
  created() {
    this.getObsSetting()
     if(this.$route.query.code!=undefined){
        this.enterpriseCode=this.$route.query.code
        this.supervisionYear=this.$route.query.year
      }
  }
}
